/* eslint-disable-next-line */
import axios from './index';

/**
 * 获取paper题型练习
 * @param {int64} id Paper DIY习题ID
 */
/* eslint-disable-next-line import/prefer-default-export */
export function getPaperQuestion(params) {
  return axios({
    url: '/paper/question',
    method: 'GET',
    params,
  });
}
